"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const objectSchema = Yup.object()
  .shape({
    branches: Yup.array()
      .min(1)
      .of(
        Yup.object().shape({
          id: Yup.string().required(),
          nodes: Yup.array()
            .min(1)
            .of(Yup.mixed())
        })
      )
  })
  .required();
class ParallelNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: objectSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.ParallelNodeValidation = ParallelNodeValidation;
//# sourceMappingURL=ParallelNodeValidation.js.map
